import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocationType } from '@guryou/core/build/locations';
import { Block, HiddenField, LocationIcon } from '@guryou/html-components';

import SelectableCubeGrid from './SelectableCubeGrid';

// Wider than StaffCube's default 145px — these labels are full phrases ("Posizione del
// Centro/Professionista" in Italian, no spaces to wrap on after the slash), not just names.
const CUBE_WIDTH = 170;

const SelectableLocationGroup = ({ onChange, value = LocationType.providerLocation }) => {
  const [selectedId, setSelectedId] = useState(value);
  const { t } = useTranslation();

  const locationOptions = [
    { id: LocationType.providerLocation, label: t('GENERAL.providerLocation') },
    { id: LocationType.mapLocation, label: t('GENERAL.chooseLocationFromMap') },
    { id: LocationType.plainNote, label: t('GENERAL.onlineLocation') },
  ];

  const items = locationOptions.map(option => ({ ...option, icon: <LocationIcon /> }));

  const selectLocation = id => {
    setSelectedId(id);
    onChange && onChange(id);
  };

  return (
    <Block margin={0} marginBottom={2}>
      <SelectableCubeGrid items={items} selectedIds={[selectedId]} onToggle={selectLocation} cubeWidth={CUBE_WIDTH} />
      <HiddenField name="locationType" value={selectedId} />
    </Block>
  );
};

export default SelectableLocationGroup;
